import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
	selector: 'app-order-content-modal',
	templateUrl: './order-content-modal.component.html',
	styleUrls: ['./order-content-modal.component.scss'],
	standalone: false,
})
export class OrderContentModalComponent {
	constructor(private modalCtrl: ModalController) {}

	static async presentModal(modalCtrl: ModalController) {
		const modal = await modalCtrl.create({
			component: OrderContentModalComponent,
			backdropDismiss: true,
			showBackdrop: true,
			cssClass: 'menu-modal',
		});
		await modal.present();
		return await modal.onDidDismiss();
	}

	dismiss() {
		this.modalCtrl.dismiss();
	}
}
